export default __webpack_public_path__ + "static/media/man.29b73066.png";